import React from 'react';
import { RouteComponentProps } from '@reach/router';
import FullPage from '../../layouts/FullPage';

// TODO: Import components

interface IEventPageProps extends RouteComponentProps { }

interface IState { }

class EventPage extends React.Component<IEventPageProps, IState> {
    // Define the constructor for the event page
    constructor (props: IEventPageProps) {
        // Pull in parent props
        super(props);
    }

    // TODO: When the component mounts
    componentDidMount () {
    }

    // Render the TSX for the event container
    render () {
        return (
            <FullPage>
                Event page
            </FullPage>
        );
    }
}

export default EventPage;
